<template>
    <v-container fluid fill-height>
        <v-layout justify-center wrap>
            <v-flex xs12 v-if="!user.valid">
                <v-alert icon="warning" type="warning" :value="true">
                    {{ $t('alerts.fix_user_data') }}
                </v-alert>

                <user-data @submit="submit" header="Stammdaten" @error="error" v-model="user"></user-data>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import UserData from '../../components/UserData';
    import { mapState } from 'vuex';

    export default {
        components: {
            'user-data': UserData
        },
        computed: mapState(['user']),
        methods: {
            submit() {
                this.$store.commit('snackBar', {
                    color: 'success',
                    text: 'Änderungen wurden gespeichert'
                });

                this.$router.push('/user/dancer');
            },
            error() {
                this.$store.commit('snackBar', {
                    color: 'error',
                    text: 'Fehler beim Speichern der Daten'
                });
            }
        }
    }
</script>
